import React from 'react';
import styled from 'styled-components';
import { NavLink } from 'react-router-dom';
import { OpenFormButton } from '../ContactForm'

export default (props) => 
    (

        <Menu className={`menu-overlay ${props.opened ? 'open' : ''}`} {...props}>

            <div className="menu-pages">
                <NavLink onClick={props.closeMenu} to="/about">ABOUT US</NavLink>
                <NavLink onClick={props.closeMenu} to="/clients">OUR CLIENTS</NavLink>
                <a href="https://locations.blueshyft.com.au" target="_blank">BROWSE NETWORK</a>

                <div className="lets-talk-small">
                    <OpenFormButton onClick={props.closeMenu}>LET'S TALK</OpenFormButton>
                </div>

            </div>

        </Menu>

    )

const Menu = styled.div`


`



// WEBPACK FOOTER //
// ./client/components/Menu/index.js